import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DateField } from "@/components/DateField";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const APPLICATION_STATUSES = { uygulandi: "Uygulandı", uygulaniyor: "Uygulanıyor", uygulanmadi: "Uygulanmadı" };
export const APPLICATION_DEFAULTS = { application_note: "", applied_by: "", application_status: "", delivery_date: "" };

export const ApplicationFields = ({ form, setForm, prefix, span = "col-span-2" }) => {
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  return (
    <>
      <div className={span}>
        <Label className="text-xs">Nasıl Uygulandığı</Label>
        <Input maxLength={500} value={form.application_note || ""} className="bg-white"
               placeholder="Ör. yol kaplaması için serildi, menfeze döşendi..."
               onChange={(e) => set("application_note")(e.target.value)} data-testid={`${prefix}-application-note-input`} />
      </div>
      <div>
        <Label className="text-xs">Uygulamayı Yapan</Label>
        <Input maxLength={200} value={form.applied_by || ""} className="bg-white" placeholder="Ekip, firma ya da kişi"
               onChange={(e) => set("applied_by")(e.target.value)} data-testid={`${prefix}-applied-by-input`} />
      </div>
      <div>
        <Label className="text-xs">Uygulama Durumu</Label>
        <Select value={form.application_status || "none"} onValueChange={(v) => set("application_status")(v === "none" ? "" : v)}>
          <SelectTrigger className="bg-white" data-testid={`${prefix}-application-status-select`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Belirtilmedi</SelectItem>
            {Object.entries(APPLICATION_STATUSES).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs">Teslim Tarihi</Label>
        <DateField value={form.delivery_date || ""} className="w-full" testId={`${prefix}-delivery-date-input`}
                   onChange={set("delivery_date")} />
      </div>
    </>
  );
};
